import { useEffect, useState } from 'react';

import { useIntersection } from '@jsmdg/yoshi';

export function useImpressionTracking(
    trackingCallback: () => void,
): (element: HTMLAnchorElement | HTMLDivElement) => void {
    const [isInViewport, setIntersectionTrackedElement] = useIntersection({
        threshold: 0.5,
    });
    const [didTrackImpression, setDidTrackImpression] = useState(false);

    useEffect(() => {
        if (isInViewport && !didTrackImpression) {
            trackingCallback();
            setDidTrackImpression(true);
        }
    }, [didTrackImpression, isInViewport, trackingCallback]);

    return setIntersectionTrackedElement;
}
